module.exports = __webpack_public_path__ + "img/order-setup-collection-bag.7a430b25.svg";